// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 705 ? "dc112a36" : chunkId) + "." + {"451":"ecd9631e8529bcee","705":"298b9353af1343a0"}[chunkId] + ".js";
};